'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _containers = require('containers');

var _components = require('components');

var _EnterpriseTabs = require('components/enterprise/EnterpriseTabs');

var _EnterpriseTabs2 = _interopRequireDefault(_EnterpriseTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Col = _components.EnterpriseGrid.Col,
    Row = _components.EnterpriseGrid.Row;

var ActionsOnProceed = function (_Component) {
  (0, _inherits3.default)(ActionsOnProceed, _Component);

  function ActionsOnProceed() {
    (0, _classCallCheck3.default)(this, ActionsOnProceed);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionsOnProceed.__proto__ || (0, _getPrototypeOf2.default)(ActionsOnProceed)).call(this));

    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
    _this.handleSendChange = _this.handleSendChange.bind(_this);
    _this.handleCommandChange = _this.handleCommandChange.bind(_this);
    _this.handlePushChange = _this.handlePushChange.bind(_this);
    _this.handleFileChange = _this.handleFileChange.bind(_this);
    _this.openFilePicker = _this.openFilePicker.bind(_this);
    _this.handleWebMethodChange = _this.handleWebMethodChange.bind(_this);
    _this.handleSoapVersionChange = _this.handleSoapVersionChange.bind(_this);
    _this.toggleDeleteAll = _this.toggleDeleteAll.bind(_this);
    _this.toggleDeleteSelected = _this.toggleDeleteSelected.bind(_this);
    _this.handleCached = _this.handleCached.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ActionsOnProceed, [{
    key: 'toggleDeleteAll',
    value: function toggleDeleteAll(e) {
      var changeProperty = this.props.changeProperty;

      changeProperty('deleteAllQuotesOnSend', e.target.checked);
    }
  }, {
    key: 'toggleDeleteSelected',
    value: function toggleDeleteSelected(e) {
      var changeProperty = this.props.changeProperty;

      changeProperty('deleteSelectedQuotesOnSend', e.target.checked);
    }
  }, {
    key: 'handleSoapVersionChange',
    value: function handleSoapVersionChange(e) {
      var handleSoapVersionChange = this.props.handleSoapVersionChange;

      handleSoapVersionChange(e.target.value);
    }
  }, {
    key: 'handleWebMethodChange',
    value: function handleWebMethodChange(e) {
      var handleWebMethodChange = this.props.handleWebMethodChange;

      handleWebMethodChange(e.target.value);
    }
  }, {
    key: 'handleFileChange',
    value: function handleFileChange(e) {
      var _props = this.props,
          wsdlLoading = _props.wsdlLoading,
          wsdlReadError = _props.wsdlReadError,
          wsdlParseError = _props.wsdlParseError,
          wsdlInvalidError = _props.wsdlInvalidError,
          wsdlSuccess = _props.wsdlSuccess;


      if (e.target.files.length) {
        wsdlLoading();
        var reader = new FileReader();
        reader.onload = loaded;
        reader.onerror = errorHandler;
        reader.readAsText(e.target.files[0]);
      }

      function loaded(evt) {
        var xmlString = evt.target.result;
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(xmlString, 'text/xml');

        // check for error
        var errNode = xmlDoc.querySelector('parsererror');
        if (errNode !== null) {
          wsdlParseError();
          return;
        }

        // extract info from xmlDoc
        // var url, webMethods, namespace, soapVersion, soapNamespace, reqMainNode, reqNamespace

        // url
        var url = xmlDoc.querySelector('service > port > address').getAttribute('location');

        // webMethods
        var methodNodes = xmlDoc.querySelectorAll('binding > operation');
        var webMethods = [];
        for (var i = 0; i < methodNodes.length; i++) {
          webMethods.push(methodNodes[i].getAttribute('name'));
        }

        // namespace
        var namespace = xmlDoc.querySelector('definitions').getAttribute('targetNamespace');

        // soapVersion - figure out if this info is in the wsdl file or not
        // soapNamespace - ?
        // reqMainNode - ?

        // reqNamespace
        var reqNamespace = xmlDoc.querySelector('definitions > types > schema').getAttribute('targetNamespace');

        // TODO: validate data
        // if invalid ->
        // wsdlInvalidError
        // return

        wsdlSuccess({ url: url, webMethods: webMethods, namespace: namespace, reqNamespace: reqNamespace });
      }

      function errorHandler(evt) {
        // TODO: inspect event better
        if (evt.target.error.name == 'NotReadableError') {}
        // dispatch error reading file

        // ?
        wsdlReadError();
      }
    }
  }, {
    key: 'handleEmailChange',
    value: function handleEmailChange(e) {
      var changeProperty = this.props.changeProperty;

      changeProperty('emailTraveler', e.target.checked);
    }
  }, {
    key: 'handleSendChange',
    value: function handleSendChange(e) {
      var changeProperty = this.props.changeProperty;

      changeProperty('shouldSendCommandWS', e.target.checked);
    }
  }, {
    key: 'handleCommandChange',
    value: function handleCommandChange(e) {
      var changeProperty = this.props.changeProperty;

      changeProperty('sendCommandWS', e.target.value);
    }
  }, {
    key: 'handlePushChange',
    value: function handlePushChange(e) {
      var changeProperty = this.props.changeProperty;

      changeProperty('pushQuotesRefNumberWS', e.target.checked);
    }
  }, {
    key: 'openFilePicker',
    value: function openFilePicker(e) {
      this.fileInput.click();
    }
  }, {
    key: 'handleCached',
    value: function handleCached() {
      var toggleCached = this.props.toggleCached;

      toggleCached();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          email = _props2.email,
          handleEmailChange = _props2.handleEmailChange;
      var _props3 = this.props,
          send = _props3.send,
          handleSendChange = _props3.handleSendChange;
      var _props4 = this.props,
          command = _props4.command,
          handleCommandChange = _props4.handleCommandChange;
      var _props5 = this.props,
          push = _props5.push,
          handlePushChange = _props5.handlePushChange;
      var _props6 = this.props,
          cached = _props6.cached,
          handleCachedChange = _props6.handleCachedChange;
      var _props7 = this.props,
          read = _props7.read,
          readFromDB = _props7.readFromDB,
          error = _props7.error,
          errorDB = _props7.errorDB;
      var namespace = this.props.namespace;
      // WSDL

      var id = this.props.id;
      var _props8 = this.props,
          methods = _props8.methods,
          selectedMethod = _props8.selectedMethod;
      var soapNamespace = this.props.soapNamespace;
      var _props9 = this.props,
          soapVersions = _props9.soapVersions,
          selectedSoapVersion = _props9.selectedSoapVersion;
      // WSDL inputs

      var _props10 = this.props,
          xmlRequestMainNode = _props10.xmlRequestMainNode,
          xmlRequestNamespace = _props10.xmlRequestNamespace;
      var _props11 = this.props,
          all = _props11.all,
          toggleDeleteAll = _props11.toggleDeleteAll,
          selected = _props11.selected,
          toggleDeleteSelected = _props11.toggleDeleteSelected;


      var active = true;
      var testOnchange = function testOnchange(e) {
        if (e.target.files.length) {
          var reader = new FileReader();
          reader.onload = function (e) {
            return console.log(e.target.result);
          };
          reader.readAsText(e.target.files[0]);
        }
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.CategoryHeader,
          null,
          'Actions on "PROCEED"'
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.line },
          _react2.default.createElement(
            'div',
            { className: _styles2.default.accountForCommandInputOffset },
            _react2.default.createElement(_components.EnterpriseCheckBox, {
              checked: all,
              onChange: this.toggleDeleteAll,
              label: 'Delete all quotes'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.line },
          _react2.default.createElement(
            'div',
            { className: _styles2.default.accountForCommandInputOffset },
            _react2.default.createElement(_components.EnterpriseCheckBox, {
              checked: selected,
              onChange: this.toggleDeleteSelected,
              label: 'Delete selected quotes'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.line },
          _react2.default.createElement(
            'div',
            { className: _styles2.default.accountForCommandInputOffset },
            _react2.default.createElement(_components.EnterpriseCheckBox, {
              checked: email,
              onChange: this.handleEmailChange,
              label: 'Email the traveler'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.line },
          _react2.default.createElement(
            'div',
            { className: _styles2.default.accountForCommandInputOffset },
            _react2.default.createElement(_components.EnterpriseCheckBox, {
              checked: send,
              onChange: this.handleSendChange,
              label: 'Send command'
            })
          ),
          send && _react2.default.createElement(
            'div',
            { style: { display: 'inline-block' } },
            _react2.default.createElement(_components.EnterpriseInput, {
              type: 'text',
              value: command,
              onChange: this.handleCommandChange,
              className: (0, _classnames2.default)(_styles2.default.mono, _styles2.default.commandInput)
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.line },
          _react2.default.createElement(
            'div',
            { className: _styles2.default.accountForCommandInputOffset },
            _react2.default.createElement(_components.EnterpriseCheckBox, {
              checked: push,
              onChange: this.handlePushChange,
              label: 'Push reference number to web service'
            })
          ),
          _react2.default.createElement(
            'div',
            null,
            push && _react2.default.createElement(
              'div',
              { className: _styles2.default.line },
              _react2.default.createElement(
                _EnterpriseTabs2.default,
                null,
                _react2.default.createElement(
                  _EnterpriseTabs.TabList,
                  null,
                  _react2.default.createElement(
                    _EnterpriseTabs.Tab,
                    null,
                    _react2.default.createElement(
                      'div',
                      null,
                      'Basic configuration'
                    )
                  ),
                  _react2.default.createElement(
                    _EnterpriseTabs.Tab,
                    null,
                    _react2.default.createElement(
                      'div',
                      null,
                      'Input parameters'
                    )
                  )
                ),
                _react2.default.createElement(
                  _EnterpriseTabs.TabPanel,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: _styles2.default.lineFirst },
                    _react2.default.createElement(
                      _components.EnterpriseButton,
                      {
                        size: 'MEDIUM',
                        type: 'PRIMARY',
                        onClick: this.openFilePicker
                      },
                      'Select file'
                    ),
                    _react2.default.createElement('input', {
                      style: { display: 'none' },
                      ref: function ref(input) {
                        return _this2.fileInput = input;
                      },
                      type: 'file',
                      onChange: this.handleFileChange
                    })
                  ),
                  (read && !error || readFromDB && !errorDB && id !== -1) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'table',
                      { className: (0, _classnames2.default)(_styles2.default.line, _styles2.default.table) },
                      _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                          'tr',
                          null,
                          _react2.default.createElement(
                            'td',
                            { className: _styles2.default.td },
                            _react2.default.createElement(
                              'div',
                              { className: _styles2.default.tableFirstColText },
                              'Web Method'
                            )
                          ),
                          _react2.default.createElement(
                            'td',
                            { className: (0, _classnames2.default)(_styles2.default.td, _styles2.default.info) },
                            _react2.default.createElement(
                              _components.EnterpriseDropDown,
                              { value: selectedMethod, onChange: this.handleWebMethodChange, className: _styles2.default.mono },
                              methods ? methods.map(function (m) {
                                return _react2.default.createElement(
                                  'option',
                                  { value: m, key: m },
                                  m
                                );
                              }) : _react2.default.createElement(
                                'option',
                                { value: selectedMethod },
                                selectedMethod
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'tr',
                          null,
                          _react2.default.createElement(
                            'td',
                            { className: _styles2.default.td },
                            _react2.default.createElement(
                              'div',
                              { className: _styles2.default.tableFirstColText },
                              'Namespace'
                            )
                          ),
                          _react2.default.createElement(
                            'td',
                            { className: (0, _classnames2.default)(_styles2.default.td, _styles2.default.info) },
                            _react2.default.createElement(_components.EnterpriseInput, {
                              type: 'text',
                              value: namespace,
                              disabled: true,
                              className: (0, _classnames2.default)(_styles2.default.mono)
                            })
                          )
                        ),
                        _react2.default.createElement(
                          'tr',
                          null,
                          _react2.default.createElement(
                            'td',
                            { className: _styles2.default.td },
                            _react2.default.createElement(
                              'div',
                              { className: _styles2.default.tableFirstColText },
                              'Soap Version'
                            )
                          ),
                          _react2.default.createElement(
                            'td',
                            { className: (0, _classnames2.default)(_styles2.default.td, _styles2.default.info) },
                            _react2.default.createElement(
                              _components.EnterpriseDropDown,
                              { value: selectedSoapVersion, onChange: this.handleSoapVersionChange, className: _styles2.default.mono },
                              soapVersions.map(function (v) {
                                return _react2.default.createElement(
                                  'option',
                                  { value: v, key: v },
                                  v
                                );
                              })
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'tr',
                          null,
                          _react2.default.createElement(
                            'td',
                            { className: _styles2.default.td },
                            _react2.default.createElement(
                              'div',
                              { className: _styles2.default.tableFirstColText },
                              'Soap Namespace'
                            )
                          ),
                          _react2.default.createElement(
                            'td',
                            { className: (0, _classnames2.default)(_styles2.default.td, _styles2.default.info) },
                            _react2.default.createElement(_components.EnterpriseInput, {
                              type: 'text',
                              value: soapNamespace,
                              disabled: true,
                              className: (0, _classnames2.default)(_styles2.default.mono)
                            })
                          )
                        ),
                        _react2.default.createElement(
                          'tr',
                          null,
                          _react2.default.createElement(
                            'td',
                            { className: _styles2.default.td },
                            _react2.default.createElement(
                              'div',
                              { className: _styles2.default.tableFirstColText },
                              'Cached'
                            )
                          ),
                          _react2.default.createElement(
                            'td',
                            { className: (0, _classnames2.default)(_styles2.default.td, _styles2.default.info) },
                            _react2.default.createElement(_components.EnterpriseCheckBox, {
                              checked: cached,
                              onChange: this.handleCached
                            })
                          )
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _EnterpriseTabs.TabPanel,
                  null,
                  _react2.default.createElement(
                    'table',
                    { className: _styles2.default.line },
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { className: _styles2.default.td },
                          _react2.default.createElement(
                            'div',
                            { className: _styles2.default.tableFirstColText },
                            'XML request main node'
                          )
                        ),
                        _react2.default.createElement(
                          'td',
                          { className: (0, _classnames2.default)(_styles2.default.td, _styles2.default.info) },
                          _react2.default.createElement(_components.EnterpriseInput, {
                            type: 'text',
                            value: xmlRequestMainNode,
                            disabled: true,
                            className: (0, _classnames2.default)(_styles2.default.mono)
                          })
                        )
                      ),
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { className: _styles2.default.td },
                          _react2.default.createElement(
                            'div',
                            { className: _styles2.default.tableFirstColText },
                            'XML request namespace'
                          )
                        ),
                        _react2.default.createElement(
                          'td',
                          { className: (0, _classnames2.default)(_styles2.default.td, _styles2.default.info) },
                          _react2.default.createElement(_components.EnterpriseInput, {
                            type: 'text',
                            value: xmlRequestNamespace,
                            disabled: true,
                            className: (0, _classnames2.default)(_styles2.default.mono)
                          })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(_containers.InputParameters, null)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ActionsOnProceed;
}(_react.Component);

exports.default = ActionsOnProceed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ActionsOnProceed/ActionsOnProceed.jsx
// module id = 1448
// module chunks = 0